package com.milta.core.localization.translations.es

import com.milta.core.localization.CommonStrings

internal val Common = CommonStrings(
    appName = "Milta",
    ok = "OK",
    cancel = "Cancelar",
    confirm = "Confirmar",
    save = "Guardar",
    delete = "Eliminar",
    back = "Volver",
    loading = "Cargando…",
    retry = "Reintentar",
    creationInProgressDoNotClose = "Creación en curso, no cierre la ventana",
    processingStepSent = "Documento enviado",
    processingStepReading = "Leyendo el documento",
    processingStepFinding = "Buscando entregas",
    processingStepChecking = "Verificando direcciones",
    processingUsualDuration = "Normalmente de 20 a 40 segundos. Permanezca en esta pantalla, nosotros nos encargamos del resto.",
    processingLongWait = "Su documento contiene mucha información, el análisis tarda un poco más de lo habitual. Todo funciona, seguimos.",
    processingInProgressSince = "En curso desde hace %1",
    processingFinishedIn = "Terminada en %1",
    processingDeliveriesFound = "%1 entregas encontradas",
    processingDeliveriesFoundOne = "1 entrega encontrada",
    processingAddressesChecked = "%1 de %2 direcciones",
    addressVerifiedBadge = "✓ Dirección verificada",
    addressNeedsReviewBadge = "⚠ Dirección por verificar",
    addressFoundLine = "Encontrada: %1",
    language = "Idioma",
    welcomeTitle = "Bienvenido a Milta",
    welcomeSubtitle = "Tu asistente inteligente de entregas",
    alreadyHaveAccount = "Ya tengo una cuenta",
    createAccount = "Crear una cuenta",
    continueWithGoogle = "Continuar con Google",
    continueWithApple = "Continuar con Apple",
    oauthErrorGeneric = "Se produjo un error al iniciar sesión. Inténtalo de nuevo.",
    oauthAppleWebComingSoon = "El inicio de sesión con Apple estará disponible pronto en la web.",
    oauthDriverAccountNotAllowedOnWeb = "Las cuentas de conductor no pueden acceder al panel web. Inicia sesión desde la aplicación móvil.",
    oauthAccountNotFoundOnWeb = "No se encontró ninguna cuenta de Milta para esta cuenta de Google.",
    errorOffline = "Sin conexión a internet.",
    navTourneesDuJour = "Rutas de hoy",
    navAjouterUneTournee = "Añadir una ruta",
    navHistoriqueDesPreuves = "Historial de entregas",
    navParametres = "Ajustes",
    sidebarRoleManagerLabel = "Gerente",
    noDeliveriesYetTitle = "Sin entregas todavía",
    noDeliveriesYetSubtitle = "Toca «Añadir entregas» para agregar algunas",
    optimizationUnavailableExplanation = "¿Quieres crear la ruta sin optimizar, o reintentarlo?",
    createWithoutOptimizationAction = "Crear sin optimizar",
    gpsAppSheetTitle = "Elegir una aplicación de navegación",
    addressSearchingLabel = "Buscando…",
    clearTimeFieldAction = "Borrar",
    clearTimeFieldConfirmTitle = "¿Borrar esta hora?",
    clearTimeFieldConfirmMessage = "Se eliminará la hora actual. Podrás indicar una nueva en cualquier momento.",
    updateRequiredTitle = "Actualización obligatoria",
    updateRequiredMessage = "Hay una nueva versión de Milta disponible. Actualiza la aplicación para seguir usándola.",
    updateInstalledVersionLabel = "Instalada",
    updateAvailableVersionLabel = "Disponible",
    updateNowButton = "Actualizar",
    updateDataKeptNote = "Tus rutas y entregas se conservan.",
    updateSendingPendingOne = "Enviando 1 entrega validada sin conexión…",
    updateSendingPendingMany = "Enviando {count} entregas validadas sin conexión…",
)
